export function validMinLength(inputString, min) {
  return inputString.length >= min;
}

export function validMaxLength(inputString, max) {
  return inputString.length <= max;
}

export function validRequired(inputString) {
  return !(inputString.trim() === '');
}
